import React, { useState } from "react";
import "../../assets/css/style.css";
import "../../assets/css/login.css";

import EditProfile from "../../components/profile/editProfile";
import NavBar from "../../components/general/NavBarApp";
import EditCompanyProfile from "../../components/profile/editCompanyProfile";
import NavBarApp from "../../components/general/NavBarApp";

const EditProfileCompanyPage = () => {
    return (
        <div className="main">
            <NavBarApp userType="entreprise" />
            <EditCompanyProfile />
        </div>
    );
};

export default EditProfileCompanyPage;
